
import React, { useEffect, useRef, useState } from 'react';
import { Divider, Table, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Typography, Modal } from 'antd';
import { QrcodeOutlined, SearchOutlined, PrinterOutlined, BarcodeOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LotCodeOpsData, LotNoInfo } from '@gtpl/shared-models/production-management';
import { LotCodeOpsService, ProdInvService } from '@gtpl/shared-services/production';
import Link from 'antd/lib/typography/Link';
import { Redirect } from 'react-router-dom';
import './production-inventory-grid.css';
import { UnitRequest } from '@gtpl/shared-models/common-models';
import moment from 'moment';
import { SoInfoViewPages } from '@gtpl/pages/sale-management/sale-pages/so-info-view-pages';
import QRCode from 'qrcode';
import Barcode from 'react-barcode';




/* eslint-disable-next-line */
export interface ProductionInventoryGridProps {
}

export function ProductionInventoryGrid(
  props: ProductionInventoryGridProps
) {
  const plantId = JSON.parse(localStorage.getItem('unit_id'))
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { Text } = Typography;
  const [saleId, setSaleId] = useState(0);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [showQRModal, setShowQRModal] = useState('')
  const [rowData, setRowData] = useState<LotCodeOpsData>()

  const [prodInvData, setProdInvData] = useState<LotCodeOpsData[]>([]);

  const productionInventoryService = new LotCodeOpsService();
  const [imageUrl, setImageUrl] = useState('');
  const [lotcode, setLotcode] = useState()






  useEffect(() => {
    getAllLotOps();

  }, []);

  const getAllLotOps = () => {
    const unitIdReq: UnitRequest = {
      unitId: plantId
    }

    console.log(plantId)
    productionInventoryService.getAllLotOps(unitIdReq).then(res => {
      if (res.status) {
        setProdInvData(res.data);
        console.log(prodInvData)
      } else {
        if (res.intlCode) {
          setProdInvData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setProdInvData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  /**
  * used for column filter
  * @param dataIndex column data index
  */
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  // const activateorDeactivateprodInv = (prodInvData:  LotCodeOpsData) => {
  //   prodInvData.weighmentReq=prodInvData.weighmentReq?false:true;
  //   productionInventoryService.activateorDeactivateprodInv(prodInvData).then(res => { console.log(res);
  //     if (res.status) {
  //        getAllLotOps();
  //       AlertMessages.getSuccessMessage('Success');
  //     } else {
  //       if (res.intlCode) {
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       } else {
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       }
  //     }
  //   }).catch(err => {
  //     AlertMessages.getErrorMessage(err.message);
  //   })
  // }



  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleCancel = () => {
    getAllLotOps();
    setIsModalVisible(false);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  //drawer related
  const closeDrawer = () => {
    setDrawerVisible(false);
  }

  const goToSaleDetailView = (saleOrderId: number) => {
    setSaleId(saleOrderId);
    console.log("soid", saleOrderId);
    setIsModalVisible(true)
  }

  const generateQR = async (record) => {
    try {

      const response = await QRCode.toDataURL(record.lotNumber);
      console.log(record, 'res')
      setImageUrl(response);
      setIsModalVisible(true);
      setShowQRModal('QRModal');
      setRowData(record)


    } catch (error) {
      console.log(error);
    }
  }

  const generateBarcode = (value) => {
    setIsModalVisible(true);
    setShowQRModal('Barcode');
    setLotcode(value.lotNumber)
    setRowData(value);

  }



  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['md'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'LOT Code',
      dataIndex: 'lotNumber',
      width: '180px',
      // responsive: ['lg'],
      sorter: (a, b) => a.lotNumber.localeCompare(b.lotNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('lotNumber')
    },

    {
      title: 'GRN Date',
      dataIndex: 'grnDate',
      sorter: (a, b) => a.grnDate.localeCompare(b.grnDate),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('grnDate'),
      responsive: ['md'],
      render: (value, record: LotCodeOpsData, index) => {
        return moment(record.grnDate).format('YYYY-MM-DD');
      }
    },
    {
      title: 'GRN Code',
      dataIndex: 'grnNumber',
      sorter: (a, b) => a.grnNumber.localeCompare(b.grnNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('grnNumber')
    },
    {
      title: 'Farmer Name',
      dataIndex: 'supplierName',
      sorter: (a, b) => a.supplierName?.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('supplierName')
    },
    {
      title: 'Farmer Code',
      dataIndex: 'supplierCode',
      sorter: (a, b) => a.supplierCode.localeCompare(b.supplierCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('supplierCode')
    },

    // title: 'SO Number',
    // dataIndex: ' soNumber',
    // sorter: (a,b) => a.soNumber.localeCompare(b.soNumber),
    // responsive: ['md'],
    // sortDirections: ['descend', 'ascend'],
    // ...getColumnSearchProps('soNumber'),

    // render: (value, record) => 
    //   <Link  onClick={e => goToSaleDetailView(record.saleOrderId)} > {record.soNumber}</Link>

    {
      title: 'Customer PO',
      dataIndex: 'poNumber',
      width: '180px',
      // responsive: ['lg'],
      sorter: (a, b) => a.poNumber.localeCompare(b.poNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('poNumber'),
      render: (value, record) =>
        <Link onClick={e => goToSaleDetailView(record.saleOrderId)} > {record.poNumber}</Link>
    },
    {
      title: 'SO Item',
      dataIndex: 'itemName',
      sorter: (a, b) => a.itemName.localeCompare(b.itemName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('itemName')
    },
    {
      title: 'Count',
      dataIndex: 'count',
      // responsive: ['lg'],
      align: 'center',

    },

    {
      title: 'Quantity',
      dataIndex: 'quantity',
      align: 'right',
      // responsive: ['lg'],

    },
    {
      title: 'Action',
      dataIndex: 'generateQr',
      render: (value, record) => {
        return <> <QrcodeOutlined onClick={(e) => { generateQR(record) }} style={{ color: '#1890ff', fontSize: '14px' }} />
          <Divider type='vertical' />
          <BarcodeOutlined onClick={(e) => { generateBarcode(record) }} style={{ color: '#1890ff', fontSize: '14px' }} /> </>
        //  <Button type='primary' size='small' onClick={(e) => { generateQR(record) }}> Generate QR</Button>
      }
    }

  ]



  /**
    * 
    * @param pagination 
    * @param filters 
    * @param sorter 
    * @param extra 
    */
  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }

  /**
  * 
  * @param selectedKeys 
  * @param confirm 
  * @param dataIndex 
  */

  const printOrder = () => {
    const divContents = document.getElementById('printme').innerHTML;
    const element = window.open('', '', 'height=700, width=1024');
    element.document.write(divContents);
    element.document.close();
    element.print();
    element.close(); // to close window when click on cancel/Save
    setIsModalVisible(true); // model should be open
  }

  const tableData = [
    {
      lotNumber: 'LOT874956',
      grnDate: '2022-04-09',
      poNumber: 'AZ43251',
      itemName: 'Vannami/31-40/VCPDTONI/SS/',
      count:20,
      quantity:'200'




    }
  ]



  return (
    <>
      {/* {(saleId) ? <Redirect  to={{ pathname: "/so-info-view", state: saleId }}/> : null} */}
      <Card title={<span style={{ color: 'white' }}>RM Inventory</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
        <br></br>
        <Row gutter={40}>
          <Col>
            <Card title={'Total: ' + prodInvData.length} style={{ textAlign: 'left', width: 215, height: 41, backgroundColor: '#bfbfbf' }}></Card>
          </Col>
          {/* <Col>
           <Card title={'Active: ' + certificationData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active: ' + certificationData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col> */}
        </Row>
        <br></br>

        <Table
          rowKey={record => record.prodInvId}
          columns={columnsSkelton}
          dataSource={prodInvData}
          scroll={{ x: true }}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered
          summary={(pageData) => {
            let totalQuantity = 0;

            pageData.forEach(({ quantity }) => {
              totalQuantity += Number(quantity);

            });

            return (
              <>
                <Table.Summary.Row className='tableFooter'>
                  <Table.Summary.Cell index={2} colSpan={9} ><Text >Total</Text></Table.Summary.Cell>
                  <Table.Summary.Cell index={3}><Text style={{ textAlign: 'end' }}>{totalQuantity}</Text></Table.Summary.Cell>
                </Table.Summary.Row>

              </>


            );
          }
          }
        />

        <Modal
          className='so-info-view'
          key={'modal' + Date.now()}
          width={showQRModal ? '30%' : '80%'}
          style={{ top: 30, alignContent: 'right' }}
          visible={isModalVisible}
          title={<React.Fragment>
          </React.Fragment>}
          onCancel={handleCancel}
          footer={[

          ]}
        >
          {
            showQRModal == 'QRModal' ?
              <>
                {imageUrl ? (
                  <html>
                    <head>
                    </head>
                    <body id='printme'>
                      <Button onClick={printOrder} className='noprint' style={{ float: 'right', backgroundColor: '#69c0ff' }}><span style={{ color: 'white' }}><PrinterOutlined /> Print</span></Button>

                      {/* <div >
                        <div style={{ border: '2px solid black', margin: '3vh' }}>
                          <h1 style={{ textAlign: 'center', marginTop: '5px', fontSize: '100px', color: '#1890ff',letterSpacing:'5px' }}>SANDHYA AQUA</h1>
                          <hr className="solid" style={{marginRight:'20px',marginLeft:'20px'}}></hr>
                          <a href={imageUrl} download>
                            <img src={imageUrl} alt="img" style={{ width: '100%' }} />
                          </a>
                          <div style={{alignContent:'center'}}>

                          <p style={{fontSize:'40px',textAlign:'center'}}><b>LOT CODE : </b>{rowData ? rowData?.lotNumber : ''} <b>  PO NUMBER : </b>{rowData ? rowData?.poNumber : ''} </p>
                          <p style={{fontSize:'40px',textAlign:'center'}}><b>ITEM</b> : {rowData ? rowData?.itemName : ''}</p>
                          </div>
                        </div>
                      </div> */}
                      <div className="ticket">
                      <h3 className="centered">SANDHYA AQUA </h3>
                        <a href={imageUrl} download>
                          <img src={imageUrl} alt="img" style={{ width: '100%' }} />
                        </a>
                        <p className="centered">{rowData ? rowData?.lotNumber : ''}
                        </p>
                        <p style={{textAlign:'center'}}>Description</p>
                        <p style={{textAlign:'center'}}>{rowData ? rowData.itemName : ''}</p>
                        {/* <table>
                          <thead>
                            <tr>
                              <th className="quantity">Cnt</th>
                              <th className="description">Description</th>
                              <th className="price">Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="quantity">{rowData ? rowData.count : ''}</td>
                              <td className="description">{rowData ? rowData.itemName : ''}</td>
                              <td className="price">{rowData ? rowData.quantity : ''}</td>
                            </tr>

                          </tbody>
                        </table> */}
                        
                      </div>
                      {/* <button id="btnPrint" className="hidden-print">Print</button> */}
                    </body>

                  </html>
                )
                  : null}

              </>



              : showQRModal == 'Barcode' ?
                <>
                  <html>
                    <head>
                    </head>
                    <body id='printme'>
                      <Button onClick={printOrder} className='hidden-print' style={{ float: 'right', backgroundColor: '#69c0ff' }}><span style={{ color: 'white' }}><PrinterOutlined /> Print</span></Button>

                      <div className="ticket">
                        <Barcode value={lotcode} style={{ width: '100%' }} />
                        {/* <p className="centered">{rowData ? rowData?.lotNumber : ''}</p> */}
                        <table>
                          <thead>
                            <tr>
                              <th className="quantity">Cnt</th>
                              <th className="description">Description</th>
                              <th className="price">Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="quantity">{rowData ? rowData.count : ''}</td>
                              <td className="description">{rowData ? rowData.itemName : ''}</td>
                              <td className="price">{rowData ? rowData.quantity : ''}</td>
                            </tr>

                          </tbody>
                        </table>
                        <p className="centered">---SANDHYA AQUA---
                        </p>
                      </div>
                      {/* <button id="btnPrint" className="hidden-print">Print</button> */}
                    </body>
                  </html>

                </> :
                <SoInfoViewPages saleOrderId={saleId} screen='production' />
          }
        </Modal>

      </Card>
    </>
  );
}

export default ProductionInventoryGrid;



